import { ButtonProps, Button as MuiButton } from '@mui/material';

export const PrimaryButton = ({
  variant = 'contained',
  color = 'secondary',
  disableElevation = true,
  ...props
}: ButtonProps) => (
  <MuiButton
    {...props}
    color={color}
    disableElevation={disableElevation}
    variant={variant}
  />
);

export const SecondaryButton = ({
  variant = 'outlined',
  color = 'secondary',
  ...props
}: ButtonProps) => <MuiButton {...props} color={color} variant={variant} />;

export const TextButton: React.FC<
  ButtonProps & {
    underline?: boolean;
  }
> = ({
  underline,
  startIcon,
  endIcon,
  children,
  variant = 'text',
  color = 'secondary',
  sx,
  ...rest
}) => {
  const showUnderline = underline ?? (!startIcon && !endIcon);
  return (
    <MuiButton
      {...rest}
      startIcon={startIcon}
      endIcon={endIcon}
      variant={variant}
      color={color}
      sx={{ textDecoration: showUnderline ? 'underline' : 'none', ...sx }}
    >
      {children}
    </MuiButton>
  );
};
